import React, { useEffect, useState } from 'react';
import AppDataTable from '../../components/AppDataTable';
import "bootstrap-icons/font/bootstrap-icons.css";
import { useNavigate } from "react-router-dom";
import { fetchAuthors } from '../../apiCalls';
export default function Authors() {

    const [authors, setAuthors] = useState([]);
    const navigate = useNavigate();
    //////////////////////////////////////////////////
    // Fetch Authors
    const getAuthorsData = async () => {
        try {
            const res = await fetchAuthors();
            setAuthors(res || []);
        } catch (error) {
            // Error handling is centralized in the service, 
            // but you can add specific UI logic here (like a toast notification)
            console.error("Component error fetching authors:", error);
        }
    };

    useEffect(() => {
        getAuthorsData();
    }, []);

    //////////////////////////////////////////////////
    // Handlers (you can connect later)
    const handleView = (row) => {
        navigate(`/view-author/${row.author_id}`, {
            state: { author: row }
        });
    };

    const handleEdit = (row) => {
        navigate(`/edit-author/${row.author_id}`, {
            state: { author: row }
        });
    };
    //////////////////////////////////////////////////
    // Table Columns
    const columns = [
        {
            name: "Photo",
            width: "90px",
            cell: (row) => (
                <img
                    src={`https://api.uyirmozhy.in/assets/images/authors/${row.author_photo}`}
                    alt="author"
                    style={{
                        width: "60px",
                        height: "60px",
                        objectFit: "cover",
                        borderRadius: "50%"
                    }}
                />
            ),
        },
        {
            name: "Author Name",
            selector: row => row.author_name,
            sortable: true,
        },
        {
            name: "Phone",
            selector: row => row.author_phone || "-",
        },
        {
            name: "Email",
            selector: row => row.author_email || "-",
        },
        {
            name: "Action",
            width: "100px",
            cell: (row) => (
                <div className="d-flex gap-2">
                    <i
                        className="bi bi-eye text-primary fs-5"
                        style={{ cursor: "pointer" }}
                        title="View"
                        onClick={() => handleView(row)}
                    ></i>

                    <i
                        className="bi bi-pencil-square text-warning fs-5"
                        style={{ cursor: "pointer" }}
                        title="Edit"
                        onClick={() => handleEdit(row)}
                    ></i>
                </div>
            ),
            ignoreRowClick: true,
        }
    ];

    //////////////////////////////////////////////////
    return (
        <>
            <div className='page-title-container'>
                <h2>Manage Authors <span>List of all authors | View, Edit or Add the authors</span></h2>
                <button className='btn btn-secondary btn-sm save-btn' onClick={() => navigate("/add-author")}>Add Author</button>
            </div>

            <AppDataTable
                columns={columns}
                data={authors}
            />
        </>
    );
}